import {
  Bar,
  BarChart,
  CartesianGrid,
  Legend,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import type { AdmissionsDayPoint } from "@/core/analytics/operational-analytics";

interface AdmissionsTrendChartProps {
  data: AdmissionsDayPoint[];
}

export function AdmissionsTrendChart({ data }: AdmissionsTrendChartProps) {
  return (
    <div className="ph-chart-wrap">
      <ResponsiveContainer width="100%" height={260}>
        <BarChart data={data} margin={{ top: 8, right: 8, left: 0, bottom: 0 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" vertical={false} />
          <XAxis
            dataKey="label"
            tick={{ fontSize: 11, fill: "#64748b" }}
            axisLine={false}
            tickLine={false}
          />
          <YAxis
            tick={{ fontSize: 11, fill: "#64748b" }}
            axisLine={false}
            tickLine={false}
            allowDecimals={false}
          />
          <Tooltip
            cursor={{ fill: "rgba(13, 148, 136, 0.06)" }}
            content={({ active, payload, label }) => {
              if (!active || !payload?.length) return null;
              return (
                <div
                  style={{
                    padding: "8px 12px",
                    borderRadius: 8,
                    border: "1px solid #e2e8f0",
                    background: "#fff",
                    fontSize: 13,
                  }}
                >
                  <div className="fw-semibold mb-1">{label}</div>
                  {payload.map((entry) => (
                    <div key={String(entry.dataKey)}>
                      {entry.name} : {entry.value}
                    </div>
                  ))}
                </div>
              );
            }}
          />
          <Legend wrapperStyle={{ fontSize: 12 }} />
          <Bar dataKey="admissions" name="Admissions" fill="#0d9488" radius={[4, 4, 0, 0]} maxBarSize={24} />
          <Bar dataKey="emergency" name="Urgences" fill="#ef4444" radius={[4, 4, 0, 0]} maxBarSize={24} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
